export const Copy = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="13" y="13" width="16" height="16" rx="1" stroke="currentColor" stroke-width="2"/>
  <path d="M10 20H5C3.89543 20 3 19.1046 3 18V5C3 3.89543 3.89543 3 5 3H18C19.1046 3 20 3.89543 20 5V10" stroke="currentColor" stroke-width="2"/>
</svg>
`;
